import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import { Skeleton } from "atoms/skeleton/Skeleton";
import TopNav from "molecules/navbars/TopNav";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/core/i18n";

export const WalletInitialSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-full flex-col">
      <TopNav>
        <h1 className="text-xl">{t("walletLayout.wallet")}</h1>
      </TopNav>
      <div className="flex gap-4 overflow-hidden px-6 pt-1">
        {[0, 1, 2].map((tab) => (
          <Skeleton key={tab} className="h-6 w-20" />
        ))}
      </div>
      <WalletSectionSkeleton />
    </div>
  );
};

export const WalletSectionSkeleton = () => (
  <div className="flex flex-col gap-4 bg-one p-4">
    <Skeleton className="h-8 w-48" />
    {[0, 1, 2, 3].map((row) => (
      <div key={row} className="flex gap-4 rounded-xl bg-white p-3">
        <Skeleton className="h-24 w-24 rounded-lg" />
        <div className="flex flex-1 flex-col justify-center gap-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    ))}
  </div>
);

export const WalletDetailSkeleton = ({
  title,
  name,
  imageUrl,
}: {
  title: string;
  name?: string;
  imageUrl?: string;
}) => {
  const navigate = useNavigate();
  return (
    <div className="bg-one">
      <TopNav startIconSVG={ChevronLeft} onStartIconClick={() => navigate(-1)}>
        <h1 className="text-xl">{title}</h1>
      </TopNav>
      <div className="flex flex-col items-center gap-4 p-4">
        {name ? (
          <h2 className="text-center font-serif text-h2">{name}</h2>
        ) : (
          <Skeleton className="h-8 w-2/3" />
        )}
        {imageUrl ? (
          <img className="h-64 w-full rounded-xl object-cover" src={imageUrl} alt={name ?? ""} />
        ) : (
          <Skeleton className="h-64 w-full rounded-xl" />
        )}
        <Skeleton className="h-10 w-28 rounded-full" />
        <Skeleton className="h-12 w-full rounded-full" />
      </div>
    </div>
  );
};
